// DS: MO3.4.2
import React from 'react';
import DeviationShopCard from '../DeviationShopCard';
const CommissionShopCard = ({ width, deviation, withAuthorDetails, allowedIndicators, withDescriptionBlock = true })=>{
    return /*#__PURE__*/ React.createElement(DeviationShopCard, {
        width: width,
        deviation: deviation,
        withStats: false,
        withDescriptionBlock: withDescriptionBlock,
        withAuthorDetails: withAuthorDetails,
        allowedIndicators: allowedIndicators
    });
};
CommissionShopCard.displayName = 'CommissionShopCard';
export default CommissionShopCard;

//# sourceMappingURL=CommissionShopCard.js.map